<template>
  <span
    class="app-icon"
    :style="{ width: size + 'px', height: size + 'px' }"
  >
    <img
      v-if="iconSrc"
      :src="iconSrc"
      :alt="name"
      class="icon-img"
    />
  </span>
</template>

<script>
export default {
  name: "Icon",
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 24,
    },
  },
  computed: {
    iconSrc() {
      if (!this.name) return null;
      try {
        // O Webpack resolve o caminho da imagem e retorna a URL tratada do bundle
        return require(`@/assets/icons/${this.name}.svg`);
      } catch (error) {
        console.warn(`[Icon.vue] Não foi possível carregar o arquivo: @/assets/icons/${this.name}.svg`, error);
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .icon-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>